export default __webpack_public_path__ + "static/media/inline-math-essay.3696e519.svg";